import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MuseumIcon(props: IconProps) {
    return <Icon {...props} iconKey={"museum"}/>
}
